// extracted by mini-css-extract-plugin
module.exports = {"table":"StaffFoodTable_table__2jePC","quantityText":"StaffFoodTable_quantityText__85RSv"};